import { initialize, isInitialized } from "./initialize";
import { interaction } from "./interaction";
import { standard } from "./standard";

export const NewRelic = {
  initialize,
  isInitialized,
  interaction,
  ...standard
};
